import React, { Component } from 'react';
import styled from 'styled-components';
import { ProductConsumer } from '../context';
import { ButtonContainer } from './StyledComponents';
import { Link } from 'react-router-dom';

export default class Modal extends Component {
  render() {
    return (
      <ProductConsumer>
        {(value) => {
          const { modalOpen, closeModal } = value;
          const { img, title, price } = value.modalProduct;
          if (!modalOpen) {
            return null;
          } else {
            return (
              <ModalContainer>
                <div className="modalContainer">
                  <div className="modalRow">
                    <div id="modal" className="modalColumn">
                      <h5>Item Added To Cart</h5>
                      <img src={img} className="modalImg" alt="Product" />
                      <h5 id="modalTitle">{title}</h5>
                      <h5 id="modalPrice">Price: ${price}</h5>
                      <Link to="/">
                        <ButtonContainer id="modalGoBack" onClick={() => closeModal()}>
                          Go Back
                        </ButtonContainer>
                      </Link>
                      <Link to="/cart">
                        <ButtonContainer cart onClick={() => closeModal()}>
                          Go To Cart
                        </ButtonContainer>
                      </Link>
                    </div>
                  </div>
                </div>
              </ModalContainer>
            );
          }
        }}
      </ProductConsumer>
    )
  }
}

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  #modal {
    background: var(--mainWhite) !important;
  }
`;